module.exports = __webpack_public_path__ + "static/media/index1.150afb07.jpg";